/* Victoria Rockera — Bloquea la accion de submit del formulario de busqueda
   para que solo se muestren resultados predictivos (sin redirigir a /search). */
(function () {
  'use strict';

  function attach() {
    var modal = document.getElementById('search-modal');
    if (!modal) return false;
    var form = modal.querySelector('.predictive-search-form');
    if (!form || form.dataset.vrNoSubmit === '1') return true;
    form.dataset.vrNoSubmit = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });

    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var target = e.target;
        var isInteractive = target && (
          target.tagName === 'A' ||
          target.tagName === 'BUTTON' ||
          target.getAttribute('role') === 'option' ||
          target.getAttribute('role') === 'button'
        );
        if (!isInteractive) {
          e.preventDefault();
        }
      }
    }, true);

    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
